import PropTypes from 'prop-types'
import { Colors } from 'Theme'

const Done = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M18.9 35.7 7.7 24.5l2.15-2.15 9.05 9.05 19.2-19.2 2.15 2.15Z" />
      </svg>
    </div>
  )
}

const Expand = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="m24 31.05-12.3-12.3 2.45-2.45L24 26.2l9.85-9.85 2.45 2.45Z" />
      </svg>
    </div>
  )
}

const ArrowUpSort = ({ height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z" />
      </svg>
    </div>
  )
}

const ArrowDownSort = ({ height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z" />
      </svg>
    </div>
  )
}

const ArrowUp = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="m282-204.651-55.566-56.131L480-514.348l253.566 253.566L678-204.651 480-403.216 282-204.651Zm0-266.001-55.566-55.566L480-780.349l253.566 254.131L678-470.652 480-669.217 282-470.652Z" />
      </svg>
    </div>
  )
}

const DoneBtn = ({
  className,
  height = 24,
  width = 24,
  fill = Colors.primary,
  onClick,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="100%"
        viewBox="0 -960 960 960"
        width="100%"
        fill={fill}
        onClick={onClick}
      >
        <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
      </svg>
    </div>
  )
}

const CloseBtn = ({
  className,
  height = 24,
  width = 24,
  fill = Colors.red,
  onClick,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 -960 960 960"
        width="24"
        fill={fill}
        onClick={onClick}
      >
        <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
      </svg>
    </div>
  )
}

const MoreInfo = ({
  className,
  height = 24,
  width = 24,
  fill = Colors.primary,
  onClick,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill={fill}
        onClick={onClick}
      >
        <path d="M249.23-420q-24.75 0-42.37-17.63-17.63-17.62-17.63-42.37 0-24.75 17.63-42.37Q224.48-540 249.23-540q24.75 0 42.38 17.63 17.62 17.62 17.62 42.37 0 24.75-17.62 42.37Q273.98-420 249.23-420ZM480-420q-24.75 0-42.37-17.63Q420-455.25 420-480q0-24.75 17.63-42.37Q455.25-540 480-540q24.75 0 42.37 17.63Q540-504.75 540-480q0 24.75-17.63 42.37Q504.75-420 480-420Zm230.77 0q-24.75 0-42.38-17.63-17.62-17.62-17.62-42.37 0-24.75 17.62-42.37Q686.02-540 710.77-540q24.75 0 42.37 17.63 17.63 17.62 17.63 42.37 0 24.75-17.63 42.37Q735.52-420 710.77-420Z" />
      </svg>
    </div>
  )
}

const ResendEmailIcon = ({ className, height = 24, width = 24, onClick }) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill={Colors.gray}
        onClick={onClick}
      >
        <path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z" />
      </svg>
    </div>
  )
}

const refresh = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M480-160q-133 0-226.5-93.5T160-480q0-133 93.5-226.5T480-800q85 0 149 34.5T740-671v-129h60v254H546v-60h168q-38-60-97-97t-137-37q-109 0-184.5 75.5T220-480q0 109 75.5 184.5T480-220q83 0 152-47.5T728-393h62q-29 105-115 169t-195 64Z" />
      </svg>
    </div>
  )
}

const CalendarMonth = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Analytics.Icons,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M212.31-100Q182-100 161-121q-21-21-21-51.31v-535.38Q140-738 161-759q21-21 51.31-21h55.38v-84.61h61.54V-780h303.08v-84.61h60V-780h55.38Q778-780 799-759q21 21 21 51.31v535.38Q820-142 799-121q-21 21-51.31 21H212.31Zm0-60h535.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-375.38H200v375.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85ZM200-607.69h560v-100q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H212.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v100Zm0 0V-720v112.31Zm280 210.77q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.04 0-14.69 10.34-25.04 10.35-10.34 25.04-10.34t25.04 10.34q10.34 10.35 10.34 25.04 0 14.7-10.34 25.04-10.35 10.35-25.04 10.35Zm-160 0q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.04 0-14.69 10.34-25.04 10.35-10.34 25.04-10.34t25.04 10.34q10.34 10.35 10.34 25.04 0 14.7-10.34 25.04-10.35 10.35-25.04 10.35Zm320 0q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.04 0-14.69 10.34-25.04 10.35-10.34 25.04-10.34t25.04 10.34q10.34 10.35 10.34 25.04 0 14.7-10.34 25.04-10.35 10.35-25.04 10.35ZM480-240q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.03 0-14.7 10.34-25.04 10.35-10.35 25.04-10.35t25.04 10.35q10.34 10.34 10.34 25.04 0 14.69-10.34 25.03Q494.69-240 480-240Zm-160 0q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.03 0-14.7 10.34-25.04 10.35-10.35 25.04-10.35t25.04 10.35q10.34 10.34 10.34 25.04 0 14.69-10.34 25.03Q334.69-240 320-240Zm320 0q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.03 0-14.7 10.34-25.04 10.35-10.35 25.04-10.35t25.04 10.35q10.34 10.34 10.34 25.04 0 14.69-10.34 25.03Q654.69-240 640-240Z" />
      </svg>
    </div>
  )
}
const Map = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.black,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="m600-141.54-240-84-172.15 66.61q-17.69 6.85-32.77-3.92Q140-173.62 140-192.31v-524.61q0-11.85 6.35-21.27 6.34-9.42 17.81-13.65L360-818.46l240 84 172.15-66.61q17.69-6.85 32.77 3.34Q820-787.54 820-769.23v527.69q0 12.23-6.92 21.46-6.93 9.23-18.77 13.46L600-141.54Zm-30-73.38v-468l-180-62.93v468l180 62.93Zm60 0L760-258v-474l-130 49.08v468ZM200-228l130-49.85v-468L200-702v474Zm430-454.92v468-468Zm-300-62.93v468-468Z" />
      </svg>
    </div>
  )
}
const ModeHeat = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M240-400q0 60.46 28.89 112.54 28.88 52.08 79.42 84-4.46-8.46-6.39-16.89Q340-228.77 340-238q0-27.77 10.66-52.31 10.65-24.54 30.57-44.46L480-431.92l99.15 97.15q19.93 19.92 30.39 44.46T620-238q0 9.23-1.92 17.65-1.93 8.43-6.39 16.89 50.54-31.92 79.42-84Q720-339.54 720-400q0-50-18.5-94.5T648-574q-20 13-42 19.5t-45 6.5q-62.38 0-107.88-41-45.5-41-52.12-101.77-39 32.62-69 68.12-30 35.5-50.5 72.38-20.5 36.89-31 74.89T240-400Zm240 52-57 56q-11 11-17 25t-6 29q0 32 23.5 55t56.5 23q33 0 56.5-23t23.5-55q0-16-6-29.5T537-292l-57-56Zm-20-456.23V-708q0 42.46 29.27 71.23Q518.54-608 561-608q18.38 0 35.04-6.92 16.65-6.92 30.58-20.39l17.61-17.76q63.23 40.46 99.5 107.96T780-400q0 125.54-87.23 212.77T480-100q-125.54 0-212.77-87.23T180-400q0-115.92 75.54-223.08Q331.08-730.23 460-804.23Z" />
      </svg>
    </div>
  )
}
const AverageTime = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M201.85-470H320q8.31 0 15.61 4.15 7.31 4.16 11.16 12.47L400-347.69l133.23-265.69q8.31-17.23 26.96-17.23 18.66 0 26.96 17.23L658.85-470h99.3Q747-575.85 667.65-647.92 588.31-720 480-720t-187.65 72.08Q213-575.85 201.85-470ZM480-160q108.31 0 187.65-72.08Q747-304.15 758.15-410H640q-8.31 0-15.61-4.15-7.31-4.16-11.16-12.47L560-532.31 426.77-266.23q-8.31 17.23-26.96 17.04-18.66-.2-26.96-17.43L301.15-410h-99.3q11.15 105.85 90.5 177.92Q371.69-160 480-160Zm0 60q-70.15 0-132-26.77-61.85-26.77-108.15-73.08-46.31-46.3-73.08-108.15Q140-369.85 140-440h60q0 116 82 198t198 82q116 0 198-82t82-198h60q0 70.15-26.77 132-26.77 61.85-73.08 108.15-46.3 46.31-108.15 73.08Q550.15-100 480-100ZM140-440q0-70.15 26.77-132 26.77-61.85 73.08-108.15 46.3-46.31 108.15-73.08Q409.85-780 480-780q60.08 0 115.73 20.39 55.65 20.38 103.35 58.38l49.84-49.84 42.15 42.15-49.84 49.84q38 47.7 58.38 103.35Q820-500.08 820-440h-60q0-116-82-198t-198-82q-116 0-198 82t-82 198h-60Zm227.69-410v-60h224.62v60H367.69ZM480-160q-116 0-198-82t-82-198q0-116 82-198t198-82q116 0 198 82t82 198q0 116-82 198t-198 82Zm0-280Z" />
      </svg>
    </div>
  )
}

const Redeem = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M160-288.46v76.15q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h615.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-76.15H160Zm12.31-410.77H283q-5-9-7.46-19t-2.46-21q0-41.92 29.04-70.96 29.04-29.04 70.96-29.04 25.15 0 46.53 13.07 21.38 13.07 37.31 32.47l22.31 29.85 22.31-29.85q15.31-20.15 37.06-32.85 21.76-12.69 46.87-12.69 41.84 0 70.87 29.04 29.04 29.04 29.04 70.96 0 11-2.27 21t-7.65 19h112.23q30.31 0 51.31 21 21 21 21 51.31v414.61Q860-182 839-161q-21 21-51.31 21H172.31Q142-140 121-161q-21-21-21-51.31v-414.61q0-30.31 21-51.31 21-21 51.31-21ZM160-391.54h640v-235.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H569.07l81.7 111.69-47.85 34.46-123.69-167.84-123.69 167.84-47.85-34.46 80.47-111.69H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v235.38Zm213.08-307.69q17 0 28.5-11.5t11.5-28.5q0-17-11.5-28.5t-28.5-11.5q-17 0-28.5 11.5t-11.5 28.5q0 17 11.5 28.5t28.5 11.5Zm212.3 0q17 0 28.5-11.5t11.5-28.5q0-17-11.5-28.5t-28.5-11.5q-17 0-28.5 11.5t-11.5 28.5q0 17 11.5 28.5t28.5 11.5Z" />
      </svg>
    </div>
  )
}
const MapPinPreview = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Analytics.Icons,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M259-212q20.92-19.92 47.35-47.77 26.42-27.84 50.57-59.77 24.16-31.92 40.12-65.92Q413-419.47 413-450.77q0-69.23-43.31-113.65-43.32-44.43-110.69-44.43-67.38 0-110.69 44.43Q105-520 105-450.77q0 31.3 15.96 65.31 15.96 34 40.12 65.92 24.15 31.93 50.57 59.77Q238.08-231.92 259-212ZM100-100v-60h126.46q-28-25.62-60.34-59.58-32.35-33.96-59.89-73.5-26-36.84-43.61-77.04Q45-410.31 45-450.58q0-93.96 61.15-156.11 61.16-62.16 152.89-62.16 91.73 0 152.84 62.16Q473-544.54 473-450.58q0 40.27-17.62 80.46-17.61 40.2-43.61 77.04-27.54 39.54-60.08 73.5T291.54-160H860v60H100Zm499.38-488.69Zm-2.84 325.23-65.77-106 31.54-62.85 34.23 55.54 34.23-55.54H800v-355.38q0-5.39-3.46-8.85t-8.85-3.46H405.77q-5.39 0-8.85 3.46t-3.46 8.85v52.31h-60v-52.31q0-30.31 21-51.31 21-21 51.31-21h381.92Q818-860 839-839q21 21 21 51.31v343.07q0 30.31-21 51.31-21 21-51.31 21H664.61l-68.07 108.85Zm-72-254.62 74.84-45.15 74.47 45.15-19.47-85.07 66.62-58-87.69-7.23-33.93-80.46-34.19 80.3-87.8 7.39 66.61 58-19.46 85.07ZM259.09-408.46q21.83 0 37.02-15.28 15.2-15.29 15.2-37.12t-15.29-37.22q-15.28-15.38-37.11-15.38t-37.03 15.36q-15.19 15.36-15.19 37.31 0 21.94 15.29 37.14 15.28 15.19 37.11 15.19Zm-.09-52.31Z" />
      </svg>
    </div>
  )
}
const Distance = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.primary,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M480-100q-101.38 0-165.69-29.1T250-204.23q0-21.31 16.04-40.08t44.35-32.23l47.23 42.85q-12.85 5.15-27.01 12.84-14.15 7.7-19.38 16.23 9.92 17.93 59.04 31.27Q419.38-160 479.81-160q60.42 0 110.04-13.35 49.61-13.34 59.54-31.27-5.08-9.15-20.5-16.84-15.43-7.69-29.27-12.85l46.61-43.46q30.69 14.08 47.23 32.85Q710-226.15 710-204.4q0 46.11-64.31 75.25Q581.38-100 480-100Zm1-195q99.38-75.31 149.19-149.19Q680-518.08 680-590.92q0-103.53-64.81-156.3-64.81-52.78-135-52.78T345-747.19q-65 52.8-65 156.38 0 68.04 49.19 141.12T481-295Zm-1 75q-130.93-97.89-195.46-190.14Q220-502.38 220-590.86q0-66.83 23.58-117.06 23.58-50.23 60.88-84.12 37.31-33.88 83.72-50.92Q434.58-860 480.06-860t91.82 17.04q46.35 17.04 83.66 50.92 37.3 33.89 60.88 84.15Q740-657.63 740-590.92q0 88.49-64.54 180.75Q610.93-317.91 480-220Zm.19-304.23q29.73 0 50.92-21 21.2-21 21.2-51.12 0-30.11-21.24-51.3-21.24-21.2-51.07-21.2-29.54 0-50.92 21.24-21.39 21.25-21.39 51.07 0 30.31 21.39 51.31 21.38 21 51.11 21Zm-.19-72.31Z" />
      </svg>
    </div>
  )
}
const LocationOn = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Analytics.Icons,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M480.07-485.39q29.85 0 51.04-21.26 21.2-21.26 21.2-51.11 0-29.85-21.26-51.05Q509.79-630 479.93-630q-29.85 0-51.04 21.26-21.2 21.26-21.2 51.12 0 29.85 21.26 51.04 21.26 21.19 51.12 21.19ZM480-99.62Q329-230.46 253.54-343.15q-75.46-112.7-75.46-206.93 0-138.46 89.57-224.19Q357.23-860 480-860t212.35 85.73q89.57 85.73 89.57 224.19 0 94.23-75.46 206.93Q631-230.46 480-99.62Z" />
      </svg>
    </div>
  )
}
const Bolt = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.black,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="m422-232 207-248H469l29-227-185 267h139l-30 208Zm-78.92 129.69 40-277.69h-185l329.61-475.77h49.23L537.31-540H757.3L392.31-102.31h-49.23ZM471-470Z" />
      </svg>
    </div>
  )
}

const MobileCharge = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M292.31-60q-29.92 0-51.12-21.19Q220-102.39 220-132.31v-695.38Q220-858 241-879q21-21 51.31-21h376.92q29.92 0 51.11 21.19 21.2 21.2 21.2 51.12v126.31q16.46 4.3 27.46 17.19 11 12.88 11 29.96v75.38q0 17.08-11 29.97-11 12.88-27.46 17.19v399.38q0 29.92-21.2 51.12Q699.15-60 669.23-60H292.31Zm0-60h376.92q5.38 0 8.85-3.46 3.46-3.46 3.46-8.85v-695.38q0-5.39-3.46-8.85-3.47-3.46-8.85-3.46H292.31q-5.39 0-8.85 3.46t-3.46 8.85v695.38q0 5.39 3.46 8.85t8.85 3.46ZM280-120v-720 720Zm181.54-175.39 110.77-221.53h-73.85v-147.69L387.69-443.08h73.85v147.69Z" />
      </svg>
    </div>
  )
}
const Database = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M480-140q-145.61 0-242.81-41.12Q140-222.23 140-283.85V-680q0-57.92 99.54-98.96Q339.08-820 480-820q140.92 0 240.46 41.04Q820-737.92 820-680v396.15q0 61.62-97.19 102.73Q625.61-140 480-140Zm0-461.69q87.46 0 176.12-24.73 88.65-24.73 102.73-53.35-13.7-29.38-101.66-54.81Q569.23-760 480-760q-89.08 0-176.58 24.73-87.5 24.73-103.04 53.96 15.16 30 102.27 54.81 87.12 24.81 177.35 24.81Zm0 200.15q41.62 0 81-4t75.27-11.69q35.88-7.69 67.19-19.08 31.31-11.38 56.54-25.77V-604q-25.23 14.38-56.54 25.77-31.31 11.38-67.19 19.07-35.89 7.7-75.27 11.7-39.38 4-81 4-42.38 0-82.58-4.2-40.19-4.19-75.88-11.88t-66.5-18.88Q224.23-589.62 200-604v141.92q24.23 14.39 55.04 25.58 30.81 11.19 66.5 18.88 35.69 7.7 75.88 11.89 40.2 4.19 82.58 4.19ZM480-200q48.69 0 95.62-6.42 46.92-6.43 85.38-17.54 38.46-11.12 64.88-25.81 26.43-14.69 34.12-30.85v-121.46q-25.23 14.39-56.54 25.77-31.31 11.39-67.19 19.08-35.89 7.69-75.27 11.69-39.38 4-81 4-42.38 0-82.58-4.19-40.19-4.19-75.88-11.89-35.69-7.69-66.5-18.88-30.81-11.19-55.04-25.58V-280q7.69 16.54 33.81 30.73 26.11 14.19 64.57 25.31 38.47 11.11 85.7 17.54Q431.31-200 480-200Z" />
      </svg>
    </div>
  )
}
const EvStation = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="m343.08-217.69 85.38-144.62h-51.15v-110.38l-85.77 144.61h51.54v110.39ZM240-550h240v-197.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H252.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46V-550Zm0 350h240v-290H240v290Zm-60 60v-607.69Q180-778 201-799q21-21 51.31-21h215.38Q498-820 519-799q21 21 21 51.31v260h44.61q27.46 0 46.81 19.34 19.35 19.35 19.35 46.81v184.62q0 19.3 15.73 34.27 15.73 14.96 35.42 14.96 20.69 0 35.92-14.96 15.24-14.97 15.24-34.27v-365.39h-11.93q-15.46 0-25.81-10.34Q705-623 705-638.46V-710h18.08v-52.31h35.38V-710h36.92v-52.31h35.39V-710h18.07v71.54q0 15.46-10.34 25.81-10.35 10.34-25.81 10.34h-11.92v365.39q0 39.3-28.77 68.11Q743.23-140 701.92-140q-40.31 0-69.58-28.81-29.26-28.81-29.26-68.11v-184.62q0-8.46-5-13.46t-13.47-5H540v300H180Zm300-60H240h240Z" />
      </svg>
    </div>
  )
}

const ArrowOutward = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M251.77-254.23 210-296l393.62-394H245.77v-60h460v460h-60v-357.85l-394 393.62Z" />
      </svg>
    </div>
  )
}
const PersonAdd = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M725-410v-120H605v-60h120v-120h60v120h120v60H785v120h-60Zm-365-82.31q-57.75 0-98.87-41.12Q220-574.56 220-632.31q0-57.75 41.13-98.87 41.12-41.13 98.87-41.13 57.75 0 98.87 41.13Q500-690.06 500-632.31q0 57.75-41.13 98.88-41.12 41.12-98.87 41.12ZM60-187.69v-88.93q0-29.38 15.96-54.42 15.96-25.04 42.66-38.5 59.3-29.07 119.65-43.61 60.35-14.54 121.73-14.54t121.73 14.54q60.35 14.54 119.65 43.61 26.7 13.46 42.66 38.5Q660-306 660-276.62v88.93H60Zm60-60h480v-28.93q0-12.15-7.04-22.5-7.04-10.34-19.11-16.88-51.7-25.46-105.42-38.58Q414.7-367.69 360-367.69q-54.7 0-108.43 13.11-53.72 13.12-105.42 38.58-12.07 6.54-19.11 16.88-7.04 10.35-7.04 22.5v28.93Zm240-304.62q33 0 56.5-23.5t23.5-56.5q0-33-23.5-56.5t-56.5-23.5q-33 0-56.5 23.5t-23.5 56.5q0 33 23.5 56.5t56.5 23.5Zm0-80Zm0 384.62Z" />
      </svg>
    </div>
  )
}
const TopUsers = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M60.39-172.31v-150q0-29 19.65-49.11 19.65-20.12 47.65-20.89H251q18.08 0 34.35 8.85 16.26 8.85 26.5 24.69 29.76 40.92 73.8 63.69 44.04 22.77 94.35 22.77 50.92 0 95.15-22.77 44.24-22.77 73.39-63.69 11.46-15.84 27.42-24.69 15.96-8.85 33.04-8.85h123.31q28.61.77 48.15 20.89Q900-351.31 900-322.31v150H640v-94.08q-34.23 26.16-74.92 40.12-40.7 13.96-85.08 13.96-43.38 0-84.19-14.08-40.81-14.07-75.43-40.23v94.31H60.39ZM480-327.69q-36.08 0-68.35-16.73-32.26-16.73-54.11-46.2-15.46-22.3-37.69-36.42-22.23-14.11-48.39-17.19 25.46-31.23 88.96-48.5Q423.92-510 480-510t119.58 17.27q63.5 17.27 89.34 48.5-25.54 3.08-48.07 17.19-22.54 14.12-38 36.42-20.85 30.47-53.31 46.7-32.46 16.23-69.54 16.23Zm-308.46-120q-45.38 0-77.69-32.31-32.31-32.31-32.31-77.69 0-46.39 32.31-78.19 32.31-31.81 77.69-31.81 46.38 0 78.19 31.81 31.81 31.8 31.81 78.19 0 45.38-31.81 77.69-31.81 32.31-78.19 32.31Zm616.92 0q-45.38 0-77.69-32.31-32.31-32.31-32.31-77.69 0-46.39 32.31-78.19 32.31-31.81 77.69-31.81 46.38 0 78.19 31.81 31.81 31.8 31.81 78.19 0 45.38-31.81 77.69-31.81 32.31-78.19 32.31ZM480-567.69q-45.38 0-77.69-32.31Q370-632.31 370-677.69q0-46.39 32.31-78.19 32.31-31.81 77.69-31.81 46.38 0 78.19 31.81Q590-724.08 590-677.69q0 45.38-31.81 77.69-31.81 32.31-78.19 32.31Z" />
      </svg>
    </div>
  )
}
const UsersActivity = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M180-187.69v-88.93q0-29.38 15.96-54.42 15.96-25.04 42.66-38.5 59.3-29.07 119.65-43.61 60.35-14.54 121.73-14.54 23.46 0 46.92 2.36 23.47 2.37 46.93 7.1v60.61q-23.46-5.53-46.93-7.8-23.46-2.27-46.92-2.27-54.7 0-108.43 13.11-53.72 13.12-105.42 38.58-12.07 6.54-19.11 16.88-7.04 10.35-7.04 22.5v28.93h333.85v60H180Zm60-60h333.85H240Zm240-244.62q-57.75 0-98.87-41.12Q340-574.56 340-632.31q0-57.75 41.13-98.87 41.12-41.13 98.87-41.13 57.75 0 98.87 41.13Q620-690.06 620-632.31q0 57.75-41.13 98.88-41.12 41.12-98.87 41.12Zm0-60q33 0 56.5-23.5t23.5-56.5q0-33-23.5-56.5t-56.5-23.5q-33 0-56.5 23.5t-23.5 56.5q0 33 23.5 56.5t56.5 23.5Zm0-80ZM730-37.7v-176.15h-68.46V-430h202.3l-76.53 152.31h75.38L730-37.7Z" />
      </svg>
    </div>
  )
}
const QueryStats = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M108.85-414.39 60-449.46 245-746l117.69 137.69 156.16-254.23 117.69 176.93L771.15-900l48.08 35.46-181.46 289-116.69-175.92L371-507.16l-118.31-138.3-143.84 231.07ZM572.31-240q45.07 0 76.19-31.12 31.12-31.12 31.12-76.19 0-45.08-31.13-76.19-31.12-31.12-76.19-31.12-45.07 0-76.19 31.12Q465-392.37 465-347.3q0 45.07 31.12 76.18Q527.24-240 572.31-240Zm205.15 140L667.15-210.31q-20.23 14.77-44.34 22.54-24.12 7.77-50.5 7.77-69.71 0-118.51-48.78Q405-277.56 405-347.24q0-69.68 48.78-118.53 48.78-48.84 118.46-48.84 69.68 0 118.53 48.79 48.84 48.8 48.84 118.51 0 26.39-7.77 50.69-7.76 24.31-22.53 44.54l109.92 110.31L777.46-100Z" />
      </svg>
    </div>
  )
}
const ElectricCar = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M224.61-380v50q0 12.75-8.62 21.37-8.63 8.63-21.38 8.63H170q-12.75 0-21.37-8.63Q140-317.25 140-330v-306.92L221.69-870q4.47-13.77 16.39-21.88Q250-900 264.62-900h432.3q14.04 0 25.5 8.25 11.45 8.25 15.89 21.75L820-636.92V-330q0 12.75-8.63 21.37Q802.75-300 790-300h-24.61q-12.75 0-21.38-8.63-8.62-8.62-8.62-21.37v-50H224.61Zm-.3-316.92h511.38L685.23-840H274.77l-50.46 143.08Zm-24.31 60V-440v-196.92Zm98.55 150.77q21.83 0 37.03-15.29 15.19-15.28 15.19-37.11t-15.28-37.03q-15.29-15.19-37.12-15.19t-37.02 15.28q-15.2 15.29-15.2 37.12t15.29 37.02q15.28 15.2 37.11 15.2Zm363.08 0q21.83 0 37.02-15.29 15.2-15.28 15.2-37.11t-15.29-37.03q-15.28-15.19-37.11-15.19t-37.03 15.28q-15.19 15.29-15.19 37.12t15.28 37.02q15.29 15.2 37.12 15.2ZM517.31-46.92 295-158.46h147.69v-74.62L665-121.54H517.31v74.62ZM200-440h560v-196.92H200V-440Z" />
      </svg>
    </div>
  )
}
const EventRepeat = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M212.31-100Q182-100 161-121q-21-21-21-51.31v-535.38Q140-738 161-759q21-21 51.31-21h55.38v-84.61h61.54V-780h303.08v-84.61h60V-780h55.38Q778-780 799-759q21 21 21 51.31v233.84h-60v-73.84H200v375.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h273.46v60H212.31ZM760-6.15q-68.38 0-120.38-42.04t-67.54-105.66h49.69q14.54 44.39 51.81 72.2 37.27 27.8 86.42 27.8 60.69 0 103.42-42.73 42.73-42.73 42.73-103.42 0-60.69-42.73-103.42-42.73-42.73-103.42-42.73-32.85 0-62.08 14.15-29.23 14.15-50.92 38.15h66.85v47.7h-147.7v-147.7h47.7v65.47q27.76-29.47 65.69-47.47 37.92-18 80.46-18 80.31 0 137.08 56.77 56.77 56.77 56.77 137.08T897.08-62.92Q840.31-6.15 760-6.15ZM200-607.69h560v-100q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H212.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v100Zm0 0V-720v112.31Z" />
      </svg>
    </div>
  )
}
const Payment = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M550-451.54q-41.92 0-70.96-29.04Q450-509.62 450-551.54q0-41.92 29.04-70.96 29.04-29.04 70.96-29.04 41.92 0 70.96 29.04Q650-593.46 650-551.54q0 41.92-29.04 70.96-29.04 29.04-70.96 29.04ZM286.15-327.69q-29.82 0-51.06-21.24-21.24-21.24-21.24-51.07v-303.08q0-29.82 21.24-51.06 21.24-21.24 51.06-21.24h527.69q29.83 0 51.07 21.24 21.24 21.24 21.24 51.06V-400q0 29.83-21.24 51.07-21.24 21.24-51.07 21.24H286.15Zm60-60h407.7q0-29.92 21.24-51.12Q796.33-460 826.15-460v-183.08q-29.92 0-51.11-21.24-21.19-21.24-21.19-51.06h-407.7q0 29.92-21.24 51.11-21.24 21.19-51.06 21.19V-460q29.92 0 51.11 21.24 21.19 21.24 21.19 51.07Zm420.77 200H146.16q-29.83 0-51.07-21.24Q73.85-230.17 73.85-260v-396.15h60V-260q0 4.61 3.84 8.46 3.85 3.85 8.47 3.85h620.76v60Zm-480.77-200h-12.3V-715.38h12.3q-5 0-8.65 3.65-3.65 3.65-3.65 8.65V-400q0 5 3.65 8.65 3.65 3.66 8.65 3.66Z" />
      </svg>
    </div>
  )
}
const Cheque = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M456.92-215h60v-40h50q12.77 0 21.39-8.62 8.61-8.61 8.61-21.38v-120q0-12.77-8.61-21.38-8.62-8.62-21.39-8.62h-130v-60h160v-60h-80v-40h-60v40h-50q-12.77 0-21.38 8.62-8.62 8.61-8.62 21.38v120q0 12.77 8.62 21.38 8.61 8.62 21.38 8.62h130v60h-160v60h80v40ZM252.31-100Q222-100 201-121q-21-21-21-51.31v-615.38Q180-818 201-839q21-21 51.31-21H570l210 210v477.69Q780-142 759-121q-21 21-51.31 21H252.31ZM540-644.62V-800H252.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v615.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-472.31H540ZM240-800v155.38V-800-160v-640Z" />
      </svg>
    </div>
  )
}
const componentPropTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
}

const components = [
  CloseBtn,
  DoneBtn,
  Done,
  Expand,
  ArrowUpSort,
  ArrowDownSort,
  ArrowUp,
  MoreInfo,
  ResendEmailIcon,
  refresh,
  CalendarMonth,
  Map,
  ModeHeat,
  AverageTime,
  Redeem,
  MapPinPreview,
  Distance,
  LocationOn,
  Bolt,
  MobileCharge,
  Database,
  EvStation,
  ArrowOutward,
  PersonAdd,
  TopUsers,
  UsersActivity,
  QueryStats,
  ElectricCar,
  EventRepeat,
  Payment,
  Cheque,
]

components.forEach((component) => {
  component.propTypes = componentPropTypes
})

export default {
  CloseBtn,
  DoneBtn,
  Done,
  Expand,
  ArrowUpSort,
  ArrowDownSort,
  ArrowUp,
  MoreInfo,
  ResendEmailIcon,
  refresh,
  CalendarMonth,
  Map,
  ModeHeat,
  AverageTime,
  Redeem,
  MapPinPreview,
  Distance,
  LocationOn,
  Bolt,
  MobileCharge,
  Database,
  EvStation,
  ArrowOutward,
  PersonAdd,
  TopUsers,
  UsersActivity,
  QueryStats,
  ElectricCar,
  EventRepeat,
  Payment,
  Cheque,
}
